"use strict";
import {
  decodeDocumentReviewStartNextResponse_NextReview,
  DocumentReviewStartNextResponse_NextReviewType
} from "../data/types/Pb";
export function getNextReviewFromContext(ctx) {
  if (!(ctx == null ? void 0 : ctx.document_review)) {
    return null;
  }
  return decodeDocumentReviewStartNextResponse_NextReview(ctx.document_review);
}
export function parseReviewPath(path) {
  return parseDocumentReviewPath(path) || parseDocumentBatchReviewPath(path) || parseDocumentGroupReviewPath(path);
}
function parseDocumentReviewPath(path) {
  const match = path.match(/document_reviews\/([^/]+)\/(\d+)/);
  if (!match) return null;
  const [, reviewType, idStr] = match;
  const reviewId = parseInt(idStr);
  switch (reviewType) {
    case "invoice_number_reviews":
      return {
        type: DocumentReviewStartNextResponse_NextReviewType.InvoiceNumberReview,
        invoiceNumberReview: { invoiceNumberReviewId: reviewId }
      };
    case "invoice_amount_reviews":
      return {
        type: DocumentReviewStartNextResponse_NextReviewType.InvoiceAmountReview,
        invoiceAmountReview: { invoiceAmountReviewId: reviewId }
      };
    case "document_type_reviews":
      return {
        type: DocumentReviewStartNextResponse_NextReviewType.DocumentTypeReview,
        documentTypeReview: { documentTypeReviewId: reviewId }
      };
    case "multi_page_bol_reviews":
      return {
        type: DocumentReviewStartNextResponse_NextReviewType.MultiPageBolReview,
        multiPageBolReview: { multiPageBolReviewId: reviewId }
      };
    case "document_load_reference_match_reviews":
      return {
        type: DocumentReviewStartNextResponse_NextReviewType.DocumentLoadReferenceMatchReview,
        documentLoadReferenceMatchReview: {
          documentLoadReferenceMatchReviewId: reviewId
        }
      };
    default:
      throw new Error(`Unknown document review type: ${reviewType}`);
  }
}
function parseDocumentBatchReviewPath(path) {
  const match = path.match(/document_batch_reviews\/([^/]+)\/(\d+)/);
  if (!match) return null;
  const [, reviewType, idStr] = match;
  const reviewId = parseInt(idStr);
  switch (reviewType) {
    case "document_batch_grouping_reviews":
      return {
        type: DocumentReviewStartNextResponse_NextReviewType.DocumentBatchGroupingReview,
        documentBatchGroupingReview: {
          documentBatchGroupingReviewId: reviewId
        }
      };
    default:
      throw new Error(`Unknown document review type: ${reviewType}`);
  }
}
function parseDocumentGroupReviewPath(path) {
  const match = path.match(/document_group_reviews\/([^/]+)\/(\d+)/);
  if (!match) return null;
  const [, reviewType, idStr] = match;
  const reviewId = parseInt(idStr);
  switch (reviewType) {
    case "document_group_load_reviews":
      return {
        type: DocumentReviewStartNextResponse_NextReviewType.DocumentGroupLoadReview,
        documentGroupLoadReview: {
          documentGroupLoadReviewId: reviewId
        }
      };
    default:
      throw new Error(`Unknown document group review type: ${reviewType}`);
  }
}
export function getReviewPath(nextReview) {
  switch (nextReview.type) {
    case DocumentReviewStartNextResponse_NextReviewType.InvoiceNumberReview:
      return `/document_reviews/invoice_number_reviews/${nextReview.invoiceNumberReview.invoiceNumberReviewId}`;
    case DocumentReviewStartNextResponse_NextReviewType.InvoiceAmountReview:
      return `/document_reviews/invoice_amount_reviews/${nextReview.invoiceAmountReview.invoiceAmountReviewId}`;
    case DocumentReviewStartNextResponse_NextReviewType.DocumentTypeReview:
      return `/document_reviews/document_type_reviews/${nextReview.documentTypeReview.documentTypeReviewId}`;
    case DocumentReviewStartNextResponse_NextReviewType.MultiPageBolReview:
      return `/document_reviews/multi_page_bol_reviews/${nextReview.multiPageBolReview.multiPageBolReviewId}`;
    case DocumentReviewStartNextResponse_NextReviewType.DocumentLoadReferenceMatchReview:
      return `/document_reviews/document_load_reference_match_reviews/${nextReview.documentLoadReferenceMatchReview.documentLoadReferenceMatchReviewId}`;
    case DocumentReviewStartNextResponse_NextReviewType.DocumentGroupLoadReview:
      return `/document_group_reviews/document_group_load_reviews/${nextReview.documentGroupLoadReview.documentGroupLoadReviewId}`;
    case DocumentReviewStartNextResponse_NextReviewType.DocumentBatchGroupingReview:
      return `/document_batch_reviews/document_batch_grouping_reviews/${nextReview.documentBatchGroupingReview.documentBatchGroupingReviewId}`;
    case DocumentReviewStartNextResponse_NextReviewType.NoReview:
      throw new Error("getReviewPath called with NoReview");
    default: {
      const _exhaustiveCheck = nextReview;
      throw new Error("Unknown review type");
    }
  }
}
